<div class="dialog-edit-category dialog">

    <div mat-dialog-title>
        @if (data.category?.id) {
        Modifier une catégorie
        } @else {
        Ajouter une catégorie
        }
    </div>
    <mat-dialog-content>
        <form [formGroup]="editCategoryFG" (ngSubmit)="submit()">

            <div class="fields-wrapper">
                <mat-form-field appearance="outline">
                    <mat-label>Code</mat-label>
                    <input matInput type="text" formControlName="shortLabel">
                    <mat-hint align="end">{{ numberCharInput('shortLabel') }} / 10</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Dénomination</mat-label>
                    <input matInput type="text" formControlName="longLabel">
                    <mat-hint align="end">{{ numberCharInput('longLabel') }} / 150</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Année de début</mat-label>
                    <mat-select formControlName="startYear">
                        @for (y of years; track $index) {
                        <mat-option [disabled]="y >= endYearValue" [value]="y">{{y}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Année de fin</mat-label>
                    <mat-select formControlName="endYear">
                        @for (y of years; track $index) {
                        <mat-option [disabled]="y <= startYearValue" [value]="y">{{y}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div mat-dialog-actions class="justify-content-end gap-3">
                <button type="button" matButton="outlined" mat-dialog-close>Annuler</button>
                <button type="submit" matButton="filled">Enregistrer</button>
            </div>
        </form>
    </mat-dialog-content>
</div>